var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusLink20Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#36AA55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 8.85742H9.57122C8.15111 8.85742 6.99988 10.0086 6.99988 11.4288V11.4288C6.99988 12.1107 7.27079 12.7648 7.75301 13.247C8.23523 13.7292 8.88926 14.0001 9.57122 14.0001H12.714C14.1341 14.0001 15.2853 12.8489 15.2853 11.4288V11.4288C15.2843 10.8873 15.111 10.3601 14.7905 9.92367",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28556 11.1427H10.7141C12.1342 11.1427 13.2854 9.99145 13.2854 8.57134V8.57134C13.2854 7.15123 12.1342 6 10.7141 6H7.57134C6.15123 6 5 7.15123 5 8.57134H5C5.00101 9.11284 5.17432 9.63997 5.49484 10.0764",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusLink20Px);
export default ForwardRef;